import { useAuth } from '../Context/AuthProvider';
import { Navigate, Outlet } from 'react-router-dom';
import { hasAccessToFeature, isAdminRole } from '../Constants/AppConstants';

const RoleProtectedRoute = ({ allowedRoles = [], requiresPms = false, requiresOms = false, feature = null }) => {
  const { role, isLoggedIn, isPms, isOms } = useAuth();

  // If not logged in, redirect to login
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // If feature-based access check is specified, use the unified helper
  if (feature) {
    const hasAccess = hasAccessToFeature(feature, role, isPms, isOms);
    if (!hasAccess) {
      return <Navigate to="/inventory" replace />;
    }
    return <Outlet />;
  }

  // ADMIN/SUPER_ADMIN roles have access to all routes (unless feature flag check required)
  if (isAdminRole(role)) {
    // Check feature flags even for admin if required
    if (requiresPms && !isPms) {
      return <Navigate to="/inventory" replace />;
    }
    if (requiresOms && !isOms) {
      return <Navigate to="/inventory" replace />;
    }
    return <Outlet />;
  }

  // Check role-based access
  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/inventory" replace />;
  }

  // Check feature flag requirements
  if (requiresPms && !isPms) {
    return <Navigate to="/inventory" replace />;
  }

  if (requiresOms && !isOms) {
    return <Navigate to="/inventory" replace />;
  }

  // User has required role and feature flags
  return <Outlet />;
};

export default RoleProtectedRoute;
